import { render, staticRenderFns } from "./ReportTypeCard.vue?vue&type=template&id=20675c9d"
import script from "./ReportTypeCard.vue?vue&type=script&lang=ts"
export * from "./ReportTypeCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports